export default "__VITE_ASSET__DcLGGfYE__"